export const adSources = {
    publica: {
        url: 'https://pbs.getpublica.com/v1/s2s-hb',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    },
    aps: {
        type: 'callback'
    }
};
